import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from '@common/components/icons';
import * as styles from '../EntityPanelSelector.module.css';

/**
 * CheckboxItem Component
 * Renders a checkbox list item
 */
export function CheckboxItem({ item, isSelected, instanceId, getItemValue, onToggle }) {
  const itemValue = getItemValue(item);
  const checkboxId = `item-${instanceId}-${itemValue}`;
  
  return (
    <li className={`${styles.item} ${isSelected ? styles.itemSelected : ''}`}>
      <input
        type="checkbox"
        className={styles.checkbox}
        id={checkboxId}
        checked={isSelected}
        onChange={() => onToggle(itemValue)}
      />
      <label htmlFor={checkboxId} className={styles.itemLabel}>
        {item.name}
      </label>
    </li>
  );
}

CheckboxItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  instanceId: PropTypes.string.isRequired,
  getItemValue: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
};

/**
 * CategoryItem Component
 * Renders a category button for 3-column left panel
 */
export function CategoryItem({ item, isSelected, getItemValue, onSelect }) {
  const itemValue = getItemValue(item);
  
  return (
    <li className={styles.categoryItem}>
      <button
        type="button"
        className={`${styles.categoryButton} ${isSelected ? styles.categoryButtonSelected : ''}`}
        onClick={() => onSelect(itemValue)}
      >
        {item.name}
      </button>
    </li>
  );
}

CategoryItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  getItemValue: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

/**
 * SelectedItem Component
 * Renders a selected item with remove button
 */
export function SelectedItem({ item, getItemValue, onRemove }) {
  const { t } = useTranslation();
  const itemValue = getItemValue(item);
  
  return (
    <li className={styles.item}>
      <span className={styles.itemLabel}>{item.name}</span>
      <button
        type="button"
        className={styles.removeButton}
        onClick={() => onRemove(itemValue)}
        aria-label={`${t('common.remove')} ${item.name}`}
      >
        <CloseIcon />
      </button>
    </li>
  );
}

SelectedItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
  }).isRequired,
  getItemValue: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

/**
 * NoDataItem Component
 * Renders a "no data" message
 */
export function NoDataItem({ message }) {
  return <li className={styles.noData}>{message}</li>;
}

NoDataItem.propTypes = {
  message: PropTypes.string.isRequired,
};

